import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { MyManagementRightsDto, MyRightsDto } from '../interfaces/dtos';
import { map, Observable } from 'rxjs';
import { MyManagementRights, MyRightsDetail } from '../interfaces/rights';
import { RightsMapper } from '../utils/rights-mapper.util';
import { MeetingTypeRightDto, MyRightsForAPointDto, MyRightsForPointsDto } from '../interfaces/dtos/rights';
import { MyRightsForAPoint, MyRightsForPoints } from '@shared/models/rights';

@Injectable({
  providedIn: 'root',
})
export class MyOwnRightsService extends BaseHttpService {
  protected endPoint: string = 'Me';

  public fetchMyOwnRights(): Observable<MyRightsDetail> {
    return this.http
      .get<MyRightsDto>(this.buildURL({ idOrSubEndpoint: 'Rights' }))
      .pipe(map((res) => RightsMapper.toMyRights(res)));
  }

  public fetchMyOwnManagementRights(): Observable<MyManagementRights> {
    return this.http
      .get<MyManagementRightsDto>(this.buildURL({ idOrSubEndpoint: 'Rights/Management' }))
      .pipe(map((res) => RightsMapper.toMyManagementRights(res)));
  }

  public fetchMyOwnRightsForMeetingPoints(): Observable<MeetingTypeRightDto[]> {
    return this.http
      .get<{ typeSeanceRights: MeetingTypeRightDto[] }>(this.buildURL({ idOrSubEndpoint: 'Rights/PointsSeances' }))
      .pipe(map((res) => res.typeSeanceRights));
  }

  public fetchMyOwnRightsForPoints(): Observable<MyRightsForPoints> {
    return this.http
      .get<MyRightsForPointsDto>(this.buildURL({ idOrSubEndpoint: 'ProfilRights/Points' }))
      .pipe(map((res) => RightsMapper.toMyRightsForPoints(res)));
  }

  public fetchMyOwnRightsForAPoint(pointId: number): Observable<MyRightsForAPoint> {
    return this.http
      .get<MyRightsForAPointDto>(this.buildURL({ idOrSubEndpoint: `Rights/Points/${pointId}` }))
      .pipe(map((res) => RightsMapper.toMyRightsForAPoint(res)));
  }
}
